import {
    GET_CLAIMS_SUCCESS,
    GET_CLAIM_BY_ID_SUCCESS,
    GET_BILL_INVOICE_PAYMENT_SUCCESS,
    GET_BILL_CLAIM_PAYMENT_TRANSACTIONS_SUCCESS,
    GET_SUBMITTED_CLAIMS_SUCCESS,
    GET_CLAIM_BATCHES_SUCCESS,
    GET_CLAIM_BATCH_BY_ID_SUCCESS,
    REFRESH_CLAIM_SUCCESS,
    GET_BILLING_OVERVIEW_SUCCESS,
    GET_CLAIM_AGING_SUCCESS,
    GET_PENDING_CLAIMS_TOTAL_SUCCESS,
    GET_BILLABLE_CLAIMS_TOTAL_SUCCESS,
    GET_COMPLETE_CLAIM_TOTALS_SUCCESS,
    GET_CLAIM_BATCH_BY_ID,
} from './claim.type';

const initialState = {
    claims: [],
    submittedClaims: [],
    claimBatches: { claimBatches: [], count: 0 },
    claimBatchById: [],
    claimById: {},
    billClaimPmt: null,
    invoiceClaimPmt: null,
    claim1500Form: null,

    billingOverviews: [],
    claimAging: [],
    pendingClaimsTotal: null,
    billableClaimsTotal: null,
    completedClaimTotals: null,
};

export const claimReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CLAIMS_SUCCESS:
            return {
                ...state,
                claims: action.payload.claims,
            };

        case GET_PENDING_CLAIMS_TOTAL_SUCCESS:
            return {
                ...state,
                pendingClaimsTotal: action.payload,
            };

        case GET_BILLABLE_CLAIMS_TOTAL_SUCCESS:
            return {
                ...state,
                billableClaimsTotal: action.payload,
            };

        case GET_CLAIM_AGING_SUCCESS:
            return {
                ...state,
                claimAging: action.payload,
            };

        case GET_COMPLETE_CLAIM_TOTALS_SUCCESS:
            return {
                ...state,
                completedClaimTotals: action.payload,
            };

        case GET_SUBMITTED_CLAIMS_SUCCESS:
            return {
                ...state,
                submittedClaims: action.payload,
            };

        case GET_CLAIM_BATCHES_SUCCESS:
            return {
                ...state,
                claimBatches: action.payload,
            };

        case GET_CLAIM_BATCH_BY_ID:
            return {
                ...state,
                claimBatchById: [],
            };

        case GET_CLAIM_BATCH_BY_ID_SUCCESS:
            return {
                ...state,
                claimBatchById: action.payload,
            };

        case GET_CLAIM_BY_ID_SUCCESS:
            return {
                ...state,
                claimById: action.payload.claimById,
            };

        case REFRESH_CLAIM_SUCCESS:
            return {
                ...state,
                claim1500Form: action.payload,
            };

        case GET_BILL_CLAIM_PAYMENT_TRANSACTIONS_SUCCESS:
            return {
                ...state,
                billClaimPmt: action.payload,
            };

        case GET_BILL_INVOICE_PAYMENT_SUCCESS:
            return {
                ...state,
                invoiceClaimPmt: action.payload,
            };

        case GET_BILLING_OVERVIEW_SUCCESS:
            return {
                ...state,
                billingOverviews: action.payload,
            };
        default:
            return state;
    }
};
